export const vi_tri = {
  HOME_TOP_SLIDERS_MTA: "home-top-sliders-mta",
};

export const slug = {
  HOMEPAGE: "landingpage-ccntaybacduchoadong-2",
};
export const collection_name = {
  APP: "app",
  ECOM_PRODUCT_LINES: "ecomproductlines",
  NEWS: "news",
  ECOM_BANNERS: "ecombanners",
  ECOM_PAGES: "ecompages",
  FOOTER: "footer",
  ECOM_CONTACTUS: "ecomcontactus",
};

export const type = {
  COUNT: "count",
  LIST: "list",
  DETAIL: "detail",
};
export const staleTime = {
  DEFAULT: 1000 * 60 * 1, // 1 minute
  LONG: 1000 * 60 * 5, // 5 minutes
  SHORT: 1000 * 60 * 10, // 10 seconds
};
export const PROJECT_INFO = {
  projectName: "",
  address: "",
  zalo: "",
  fb: "",
  youtube: "",
  sdt: "",
  email: "",
  website: "",
};
